/**
 * Section registry. Maps a section's `type` to its component.
 *
 * To add a NEW section type:
 *   1. add the interface + union member in src/data/profile.ts
 *   2. build a component in ./sections that takes `SectionProps<YourType>`
 *   3. add one `case` below
 * The switch is exhaustive, so TypeScript flags any type you forget to wire up.
 */

import type { Section } from "@/data/profile";
import type { SectionCtx } from "./types";
import { AboutSection } from "./sections/AboutSection";
import { TimelineSection } from "./sections/TimelineSection";
import { SkillsSection } from "./sections/SkillsSection";
import { LinksSection } from "./sections/LinksSection";
import { ContactSection } from "./sections/ContactSection";

export function SectionView({ section, number, ctx }: { section: Section; number: string; ctx: SectionCtx }) {
  switch (section.type) {
    case "about":
      return <AboutSection section={section} number={number} ctx={ctx} />;
    case "timeline":
      return <TimelineSection section={section} number={number} ctx={ctx} />;
    case "skills":
      return <SkillsSection section={section} number={number} ctx={ctx} />;
    case "links":
      return <LinksSection section={section} number={number} ctx={ctx} />;
    case "contact":
      return <ContactSection section={section} number={number} ctx={ctx} />;
    default: {
      const _exhaustive: never = section;
      return _exhaustive;
    }
  }
}
